export default {
  productCount: {
    id: 'outlet_category_product_count',
    defaultMessage: `{count, plural,
      one {# product}
      other {# products}
    }`,
  },
  paginationLabel: {
    id: 'outlet_category_pagination_label',
    defaultMessage: 'pagination',
  },
  paginationNext: {
    id: 'outlet_category_pagination_next',
    defaultMessage: 'Next',
  },
  paginationPrevious: {
    id: 'outlet_category_pagination_previous',
    defaultMessage: 'Previous',
  },
  paginationGoToPage: {
    id: 'outlet_category_pagination_go_to_page',
    defaultMessage: 'Go to page {page}',
  },
  countdownPrefix: {
    id: 'outlet_category_card_countdown_prefix',
    defaultMessage: 'ends in',
  },
}
